export default "__VITE_ASSET__DV$C3r53__"